import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { displayFormattedDate, formatCurrency, isEmpty } from '../../../generalFunctions';
import { FIRM_NAME } from '../../../constants';

const styles = StyleSheet.create({
    rowView: {
        flexDirection: 'row', border: '1px solid #000', padding: 10, textAlign: "left", alignSelf: "flex-start", marginRight: 25
    }
});

const CompanyBillGST = (props) => {
    const { startDate, endDate } = props.dates;
    const cgstRate = props.data[0]?.cgstRate;
    const sgstRate = props.data[0]?.sgstRate;
    const igstRate = props.data[0]?.igstRate;
    let totalTaxable = 0; let totalCGST = 0; let totalSGST = 0; let totalIGST = 0;
    props.data?.forEach((element, index) => {
        element.billDate = displayFormattedDate(element.billDate);

        totalTaxable = totalTaxable + element.basicAmount;
        totalCGST = totalCGST + element.cgst;
        totalSGST = totalSGST + element.sgst;
        totalIGST = totalIGST + element.igst;

        element.basicAmount = Number(element.basicAmount).toFixed(2);
        element.cgst = Number(element.cgst).toFixed(2);
        element.sgst = Number(element.sgst).toFixed(2);
        element.igst = Number(element.igst).toFixed(2);
    });

    props.data.push({
        basicAmount: Number(totalTaxable).toFixed(2),
        cgst: Number(totalCGST).toFixed(2),
        sgst: Number(totalSGST).toFixed(2),
        igst: Number(totalIGST).toFixed(2),
    });

    const tableData = {
        columnName: ["Entry No", "Inv No", "Inv Dt", "Company Name", "GSTIN", "Taxable", `CGST ${Number(cgstRate).toFixed(2)}`, `SGST ${Number(sgstRate).toFixed(2)}`, `IGST ${Number(igstRate).toFixed(2)}`, "RO No"],
        column: ["id", "billNumber", "billDate", "accountName", "gstNumber", "basicAmount", "cgst", "sgst", "igst", "roId"],
        width: [5, 7, 10, 26, 15, 9, 7, 7, 7, 7],
        align: ["left", "left", "left", "left", "left", "right", "right", "right", "right", "right"],
        data: props.data
    }

    return (
        <Page style={{ padding: 15 }} id={props.data.id} orientation="landscape">
            <View style={{ flexDirection: "row", paddingBottom: 5, paddingTop: 7, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 16,
                    flexDirection: "column",
                    flexGrow: 1
                }}>{FIRM_NAME}</Text>
            </View>
            <View style={{ flexDirection: 'row', textAlign: "center", marginBottom: 15 }}>
                <Text style={{ fontSize: 9, fontWeight: "bold", marginRight: 5 }}>{`Company GST Tax Report for the period: ${displayFormattedDate(startDate)} To ${displayFormattedDate(endDate)}`}</Text>
            </View>
            <View style={{ innerHeight: "80%" }}>
                <View style={styles.rowView}>
                    {tableData["columnName"].map((c, index) => <Text key={index} style={{
                        width: `${tableData["width"][index]}%`, textAlign: `${tableData["align"][index]}`, fontSize: 9, marginRight: 1
                    }}>{c.toUpperCase()}</Text>)}
                </View>
                {tableData["data"].map((rowData) => <>
                    <View style={{ flexDirection: 'row', border: '1px solid #000', padding: 9, alignSelf: "flex-start", marginRight: 25 }}>
                        {tableData["column"].map((c, index) =>
                            <Text key={index} style={{ width: `${tableData["width"][index]}%}%`, textAlign: `${tableData["align"][index]}`, fontSize: 9 }}>{rowData[c]}</Text>
                        )}
                    </View>
                </>)}
            </View>
        </Page>
    );
}

export default CompanyBillGST;